<template>
  <v-container v-if="showLoader">
    <div class="text-center mt-6">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
        class="mb-4"
      ></v-progress-circular>
      <h1 class="text-h4 text-subtitle-2">{{ message }}</h1>
      <p class="text-body-2 text-gray-600">We will be done shortly.</p>
    </div>
  </v-container>
</template>

<script setup>
const props = defineProps({
  showLoader: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "Loading...",
  },
});
</script>
